import React, { useEffect } from 'react';
import { useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { fetchTip } from "../../../actions/mine_craft/tipsActions";
import { fetchTipSteps } from "../../../actions/mine_craft/tipStepsActions";
import { selectTipById } from "../../../store/mine_craft/tipsSlice";
import { queryParams } from "../../../helpers/UrlHelpers";
import minecraftUrls from "../../../configs/mine_craft/minecraftUrls";

import Wrapper from "../../../componets/Wrapper";
import NavBarThree from "../../../componets/NavBarThree";
import { PlusOutlined } from "@ant-design/icons";
import { setNewParams } from "../../../store/mine_craft/tipStepsSlice";
import PageLayout from '../_partials/PageLayout';

import List from "./_partials/_List";
import New from "./New";
import Edit from "./Edit";
import PageHeader from "../../../componets/PageHeader";
import SidebarIndex from "./_partials/_SidebarIndex";
import NavBarTwo from "../../../componets/NavBarTwo";
import Can from "../../../componets/Can";
import './style.scss';

const LIMIT = 50;

const TipSteps: React.FC = () => {
  const dispatch        = useAppDispatch();
  const [searchParams]  = useSearchParams();
  const currentPage     = queryParams.getInt(searchParams,'page') || 1;
  const tipId           = queryParams.getInt(searchParams,'tip_id');
  const tip             = useAppSelector(state => tipId ? selectTipById(state, tipId) : undefined);

  useEffect(() => {
    const params: any = {
      tip_id: tipId,
      limit: LIMIT,
      offset: (currentPage - 1) * LIMIT
    };

    if (tipId) {
      dispatch(fetchTip(tipId));
    }
    dispatch(fetchTipSteps(params))
  }, [tipId, currentPage, dispatch]);

  function onClickCreate() {
    const params: any = { tip_id: tipId };
    dispatch(setNewParams(params));
  }

  return (
    <PageLayout className='v-tipSteps-page'>
      <PageHeader
        breadcrumbs={['Helps', tip?.title]}
        title='Help Steps'
      >
        <NavBarTwo
          items={{}}
          itemIds={[]}
          activeId={1}
          parent={{
            name: 'Helps',
            url: minecraftUrls.tipsPath()
          }}
        />
      </PageHeader>

      <Can capability='write_minecraft'>
        <Wrapper>
          <NavBarThree>
            <NavBarThree.Button className='v-link2' onClick={onClickCreate}>
              <PlusOutlined /> Add Step
            </NavBarThree.Button>
          </NavBarThree>
        </Wrapper>
      </Can>

      <div className='v-container'>
        <List limit={LIMIT} />
      </div>

      <SidebarIndex />

      <New />
      <Edit />
    </PageLayout>
  );
}

export default TipSteps;
